/**
 * 游戏socket管理类
 */

import superManager from "./superManager";
import O1HD, {managers, modules, services} from "../gameEngine";
import {$WS} from "../../WsSdk/webSocketProtocol/webSocketProtoHead";
import SSubLoginGame from "../../WsSdk/webSocketProtocol/wsInstanceList/SSubLoginGame";
import data_control from "../libs/data_control";
import CSubLoginServer from "../../WsSdk/webSocketProtocol/wsInstanceList/CSubLoginServer";
import SSubLoginServer from "../../WsSdk/webSocketProtocol/wsInstanceList/SSubLoginServer";
import SSubRushLogin from "../../WsSdk/webSocketProtocol/wsInstanceList/SSubRushLogin";
import SSubMatchRoom from "../../WsSdk/webSocketProtocol/wsInstanceList/SSubMatchRoom";
import SSubExitRoom from "../../WsSdk/webSocketProtocol/wsInstanceList/SSubExitRoom";
import {MSG} from '../../WsSdk/proto/proto'
import {PLATFORM_CODE} from "../services/ossService";
import SCSubGameSync from "../../WsSdk/webSocketProtocol/wsInstanceList/SCSubGameSync";
import FpsSyncListMsg from "../../WsSdk/webSocketProtocol/wsInstanceList/FpsSyncListMsg";

export interface GameClient {
    //
    readonly gameId: number;
    //
    readonly gameName: string;

    //游戏消息
    onGameMessage(head: number, body: Uint8Array): Promise<void>;

    //游戏同步消息
    onGameSyncMessage(msg: SCSubGameSync): Promise<void>;

    //帧同步消息
    onFpsGameSyncMessage(msg: FpsSyncListMsg): Promise<void>;

    //发送游戏消息
    sendGameMessage: (cMsg: Uint8Array) => void;

    //发送大厅消息
    sendHallMessage: (cMsg: $WS.WebSocketProtoHeadBody | Uint8Array) => void;

    //
    sendSyncMessage: (msg: Uint8Array) => void;
}


export default class GameSocketManager extends superManager {
    //
    className: string = '游戏socket管理';
    //服务器地址
    // private m_serverUrl: string = 'ws://127.0.0.1:8288'; //个人测试
    private m_serverUrl: string = 'wss://socket.tobetopone.com/socket';
    //本地nginx IP
    // private m_serverUrl: string = 'ws://127.0.0.1/socket';
    //地址

    private m_ws: WebSocket;
    //
    private m_gameClient: GameClient;

    private readonly USER_ID_KEY: string = 'web-socket-user-id';
    private m_userId: string;
    private m_rmId: number;
    private m_seatI: number = -1;
    private m_loginIng: boolean = false;
    private m_heartInterValId: number;

    private m_pingTimeC: number = 0;

    constructor() {
        super();
    }

    async loadManager(): Promise<boolean> {
        await super.loadManager();
        //
        this.onloadUserId();
        //
        const connected = true;
        // const connected = await this.connectServer();
        //
        return Promise.resolve(connected);
    }

    //连接服务器
    async connectServer(isReconnect?: boolean): Promise<boolean> {
        return new Promise(resolve => {
            console.log('socket url', this.m_serverUrl);
            this.m_ws = new WebSocket(this.m_serverUrl);
            //连接过程中……
            this.m_ws.onerror = (e) => {
                if (isReconnect) {
                    resolve(false);
                } else {
                    console.error('#661546 连接错误', e);
                    // modules().uiControlModule.showDialogBox('连接失败!', '服务器连接失败', false, isOk => {
                    // cc.game.end();
                    // });
                    resolve(false);
                }
            }
            //
            this.m_ws.onopen = (e) => {
                this.m_ws.binaryType = 'arraybuffer';
                this.m_ws.onerror = this.onWebsocketError.bind(this);
                this.m_ws.onclose = this.onWebsocketClose.bind(this);
                this.m_ws.onmessage = this.onWebsocketMessage.bind(this);
                //
                this.onWebsocketOpen(e);
                //
                this.onLoginServer().then(res => {
                    if (res) {
                        this.onHeart();
                    }
                    resolve(res);
                });
            };
        });
    }

    bindRmId(rmId: number) {
        this.m_rmId = rmId;
    }

    bindSeatI(i: number) {
        this.m_seatI = i;
    }

    getRmId() {
        return this.m_seatI;
    }

    getSeatI() {
        return this.m_seatI;
    }

    getUserId() {
        return this.m_userId;
    }

    onHeart() {
        if (this.m_heartInterValId) {
            clearInterval(this.m_heartInterValId);
        }
        //发送心跳包
        const net = MSG.Msg.encode({msgType: $WS.ProtoHead.PING}).finish();
        this.m_pingTimeC = Date.now();
        this.sendMessage(net);
        this.m_heartInterValId = setInterval(() => {
            this.m_pingTimeC = Date.now();
            this.sendMessage(net);
        }, $WS.HEART_SEND_TIME);
    }

    //登录服务器
    async onLoginServer(): Promise<boolean> {
        this.m_loginIng = true;
        return new Promise(resolve => {
            const cMsg = new CSubLoginServer(this.getUserId());
            this.sendMessage(cMsg);
            let key = setInterval(() => {
                //登录中
                if (this.m_loginIng) return;
                //
                clearInterval(key);
                resolve(true);
            }, 10);
            cc.game.on(cc.game.EVENT_HIDE, () => {
                this.m_ws.close();
            });
        });
    }

    //登录完成
    protected onLoginServerSuccess() {
        this.m_loginIng = false;
    }

    protected onloadUserId() {
        let id = services().localStorageSrv.getStorage(this.USER_ID_KEY, false);
        if (!id) {
            id = data_control.getRandId(16);
            services().localStorageSrv.setStorage(this.USER_ID_KEY, id, false);
        }
        this.m_userId = id;
    }

    protected changeUserId(uid: string) {
        this.m_userId = uid;
        services().localStorageSrv.setStorage(this.USER_ID_KEY, uid, false);
    }

    onServerUserId(userId: string) {
        if (this.getUserId() != userId) {
            this.changeUserId(userId);
        }
    }

    destroyCurrGameClient() {
        delete this.m_gameClient;
        this.m_gameClient = null;
    }

    registerGameClient(client: GameClient) {
        if (this.m_gameClient) {
            this.destroyCurrGameClient();
        }
        this.m_gameClient = client;
    }

    sendHallMessage(data: $WS.WebSocketProtoHeadBody) {
        this.sendMessage(data);
    }

    sendGameMessage(data: Uint8Array) {
        this.sendMessage(data);
    }

    sendMessage(msg: Uint8Array | $WS.WebSocketProtoHeadBody) {
        // if (msg != 'ping.') {
        // console.debug('sr发送数据到服务器', msg);
        let u8: Uint8Array = null;
        if (msg instanceof Uint8Array) {
            u8 = msg;
        } else {
            u8 = msg.getPackageBody();
        }
        this.m_ws.send(u8.slice().buffer);
    }

    private async onResetConnectServer() {
        //清除心跳
        this.m_heartInterValId != null && clearInterval(this.m_heartInterValId);
        this.m_heartInterValId = null;
        const func = () => {
            try {
                modules().uiControlModule.showDialogBox('连接断开', '与服务器连接断开，请重新连接', false, isOk => {
                    func();
                    // cc.game.end();
                });
            } catch (e) {
                // O1HD.emit('loading-title', '与服务器连接断开，请重新连接');
            }
        }
        func();
        return;
        //
        // console.log('正在重连……');
        // await modules().uiControlModule.showLoading(null, '与服务器断开连接，正在重连');
        // let reConnectSuccess = false;
        // let count = 0;
        // while (!reConnectSuccess) {
        //     console.log('第', ++count, '次重连');
        //     reConnectSuccess = await this.connectServer(true);
        // }
        // modules().uiControlModule.hideLoading();
    }

    private onWebsocketError(e) {
        console.log('socket连接错误', e);
        this.onResetConnectServer().then();
    }

    private onWebsocketClose(e) {
        console.log('socket连接关闭', e);
        this.onResetConnectServer().then();
    }

    private onWebsocketOpen(e) {
        console.log('socket连接成功', e);
    }

    protected onUserComeIn(msg: SSubMatchRoom) {
        if (msg.body.userId == this.getUserId()) {
            this.bindSeatI(msg.body.seatI);
        }
    }

    protected onUserGoOut(msg: SSubExitRoom) {
        if (msg.body.uid == this.getUserId()) {
            this.bindSeatI(-1);
        }
    }

    private async onFpsGameSyncMessage(msg: FpsSyncListMsg) {
        if (!this.m_gameClient) {
            console.error('#2822114 没有游戏运行 %s', msg);
            return;
        }
        await this.m_gameClient.onFpsGameSyncMessage(msg);
    }

    private async onGameSyncMessage(msg: SCSubGameSync) {
        if (!this.m_gameClient) {
            console.error('#1311716 没有游戏运行 %s', msg);
            return;
        }
        await this.m_gameClient.onGameSyncMessage(msg);
    }

    protected async onGameMessage(message: Uint8Array) {
        // console.debug('游戏消息', data);
        if (!this.m_gameClient) {
            console.error('#1311716 没有游戏运行 %s', message);
            return;
        }
        const sMsg = MSG.GameMsg.decode(message);
        const gameId = sMsg['gameId'];
        const gameHead = sMsg['gameHead'];
        if (this.m_gameClient.gameId != gameId) {
            console.error('#1361720 游戏已经切换，数据还未切换', this.m_gameClient.gameId, this.m_gameClient.gameName, message);
            return;
        }

        switch (gameHead) {
            case SSubMatchRoom.HEAD: {
                this.onUserComeIn(SSubMatchRoom.unPackageMessage(message));
                break;
            }
            case SSubExitRoom.HEAD: {
                this.onUserGoOut(SSubExitRoom.unPackageMessage(message));
                break;
            }
        }
        await this.m_gameClient.onGameMessage(gameHead, message);
    }

    protected async onHallMessage(message: Uint8Array) {
        const sMsg = MSG.HallMsg.decode(message);
        console.log('大厅消息', sMsg);
        switch (sMsg.hallHead) {
            case SSubLoginServer.HEAD: {
                const res = SSubLoginServer.unPackageMessage(message);
                this.onServerUserId(res.body.userId);
                this.onLoginServerSuccess();
                break;
            }
            case SSubLoginGame.HEAD: {
                const res = SSubLoginGame.unPackageMessage(message);
                //有错误码
                if (res.body.loginCode) {
                    managers().gameMgr.onLoginFailGameServer(res.body.loginMsg);
                } else {
                    managers().gameMgr.onLoginSuccessGameServer(res.body.gameId);
                }
                break;
            }
            case SSubRushLogin.HEAD: {
                this.m_ws.close();
                O1HD.emit('loading-title', '此账号正在游戏中');

                // modules().uiControlModule.showDialogBox('异地登录', '您的账号在其他地方登录\n您将被强制下线', false, isOk => {
                //     cc.game.end();
                // });
                break;
            }
            default: {
                console.error('#1341833 协议不对等', sMsg);
                break;
            }
        }
    }

    private onWebsocketMessage(e: MessageEvent) {
        // if (e.data != 'pong.') {
        const u8 = new Uint8Array(e.data);
        // }
        try {
            const head = $WS.unPackageMessage(u8);
            // console.debug('sr服务器数据来临%s', e.data);
            switch (head) {
                case $WS.ProtoHead.HALL: {
                    this.onHallMessage(u8).then();
                    break;
                }
                case $WS.ProtoHead.GAME: {
                    this.onGameMessage(u8).then();
                    break;
                }
                case $WS.ProtoHead.PONG: {
                    const t = Date.now() - this.m_pingTimeC;
                    O1HD.emit('ping-time', t);
                    break;
                }
                case $WS.ProtoHead.SYNC: {
                    //是否为同步
                    let msg = SCSubGameSync.unPackageMessage(u8);
                    this.onGameSyncMessage(msg).then();
                    break;
                }
                case $WS.ProtoHead.FPS_SYNC: {
                    let msg = FpsSyncListMsg.unPackageMessage(u8);
                    this.onFpsGameSyncMessage(msg).then();
                    break;
                }
                default: {
                    break;
                }
            }
        } catch (e) {
            console.error('#931658 错误的消息', u8, e);
        }
    }

    getWebSocketObject() {
        return this.m_ws;
    }
}